export default __webpack_public_path__ + "img/a8936f67d0d26ddf14c2fb6877c9f1ec.svg";